<template>
  <div>
    <div class="modal__content-title">
      <span class="modal__wo-id h-color-fuel-blue">FM{{ item.work_order_id }}</span>
      <span class="modal__item-title" v-html="item.title"></span>
      <div class="modal__item-details" v-if="item.details" v-html="item.details"></div>
    </div>
    <div class="modal__wo-objective h-italic-text" v-if="item.objective">{{ item.objective }}</div>
    <div class="grid modal__wo-meta-data">
      <div class="grid__col-no-gutter--4 h-no-padding">
        <People :item="item"></People>
        <FileAttachments :item="item"></FileAttachments>
      </div>
      <div class="grid__col-no-gutter--8 h-no-padding">
        <div class="modal__info-pills">
          <div class="modal__info-pill modal__wo-status">
            <div class="modal__wo-status-dot"  :class="`modal__wo-status-dot--${statusClass}`"></div>
            {{ statusTitle }}
          </div>
          <div class="modal__info-pill modal__wo-department">
            <span class="glyphicon queue-detail__glyph" :class="[departmentIcon, `queue-detail__glyph--${item.department}`]" aria-hidden="true"></span></a>
            {{ departmentTitle }}
          </div>
          <div class="modal__info-pill modal__wo-specialty">{{ item.specialty }}</div>
          <div class="modal__info-pill modal__wo-created">
            <span class="glyphicon queue-detail__glyph glyphicon-calendar h-color-fuel-navy" aria-hidden="true" v-tooltip="{ content:`Start Date: ${startDate}` }"></span>
            {{ startDate }}
          </div>
          <div class="modal__info-pill modal__wo-time-spent">
            <span class="glyphicon queue-detail__glyph glyphicon-time h-color-fuel-navy" aria-hidden="true" v-tooltip="{ content: 'Time Spent' }"></span>
            {{ item.timeSpent }} min
          </div>
        </div>
        <div class="modal__item-row">
          <div class="grid modal__wo-note-container" v-if="item.note">
            <div class="grid__col--1 h-no-padding h-right-align">
              <i class="fas fa-sticky-note h-color-fuel-navy"></i>
            </div>
            <div class="grid__col--11 h-no-margin h-no-padding modal__wo-note" v-html="item.note"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import FileAttachments from './files/FileAttachments.vue';
  import People from './people/People.vue';

  export default {
    name: 'WorkOrder',
    components: {
      FileAttachments,
      People,
    },
    props: ['item', 'index'],
    data() {
      return {
        asIsStatuses: ['hold', 'member review', 'killed', 'scheduled'],
        completeStatuses: ['complete'],
      };
    },
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgenda', 'titleTransforms', 'glyphs']),
      startDate() {
        return this.displayDate(this.item.startDate !== '0000-00-00' ? this.item.startDate : this.item.submittedDate, 'MM/DD/YYYY')
      },
      departmentTitle() {
        const transform = lodash.find(this.titleTransforms, titleTransform => titleTransform.value === this.item.department);
        return transform !== undefined ? transform.transform : lodash.startCase(this.item.department);
      },
      departmentIcon() {
        if (this.item.department !== null && this.item.department !== undefined) {
          const icon = lodash.find(this.glyphs, { status: this.item.department });
          if (icon !== undefined) {
            return `glyphicon-${icon.icon}`;
          }
        }
        return '';
      },
      statusTitle() {
        let status = '';
        if (this.asIsStatuses.includes(this.item.status)) {
          status = this.item.status;
        } else if (this.completeStatuses.includes(this.item.status)) {
          status = 'complete';
        } else {
          status = 'in progress';
        }
        const transform = lodash.find(this.titleTransforms, titleTransform => titleTransform.value === lodash.startCase(status));
        return transform !== undefined ? transform.transform : lodash.startCase(status);
      },
      statusClass() {
        return lodash.kebabCase(this.statusTitle);
      },
      formattedTitle() {
        return this.item.title.replace(/ - /g, '<br />');
      },
    },
    methods: {
      displayDate(aDate, format) {
        if (aDate !== null && aDate !== '') {
          return moment(aDate).format(format);
        }
        return aDate;
      },
    },
  };
</script>

